import FlexSection from "@/partials/sections/Section/FlexSection";
import Link from "next/link";
import React from "react";

export default function MenuItemLinks({ toggleDrawer, customer }) {
  return (
    <FlexSection extraClass="text-lg font-bold space-y-2 pb-8  flex-col ">
      <Link href="/about" onClick={toggleDrawer}>
        About Us
      </Link>
      <Link href={"/gallery"} onClick={toggleDrawer}>
        Gallery
      </Link>
      <Link href={"/events"} onClick={toggleDrawer}>
        Events
      </Link>
      <Link href={"/journals"} onClick={toggleDrawer}>
        Journals
      </Link>
      <Link href={"/writeups"} onClick={toggleDrawer}>
        Writeups
      </Link>
      <Link href={"/contactUs"} onClick={toggleDrawer}>
        Contact
      </Link>
      <Link href={"/apbc"} onClick={toggleDrawer}>
        APBC
      </Link>
      {customer?._id && (
        <Link href={"/profile"} onClick={toggleDrawer}>
          Profile
        </Link>
      )}
    </FlexSection>
  );
}
